import style from './style.module.scss'
import { TextBlock } from '@crossfit/design-system'

type Props = {
  bodyText: string
}

function TextBlockContainer({ bodyText }: Props) {
  return (
    <section className={style.wrapper}>
      <TextBlock>{bodyText}</TextBlock>
    </section>
  )
}

export default TextBlockContainer
